import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Helpers } from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';
import { fetchProducts, sortProducts, prefetchProducts } from '../product-actions';
import { ProductList } from './product-list';

const { memoize } = Helpers;

// TODO: utilize memoize to prevent extra rerenders
const getActivePG = memoize(
    (pgKey, productList) => {
        return productList[pgKey];
    },
    (pgKey, productList) => `${pgKey}-${pgKey in productList ? productList[pgKey].prefetch : 'na'}`,
);

const mapStateToProps = (state, ownProps) => {
    const { sortedProducts } = ownProps;
    const { productData } = state;
    const { productInfo } = productData;
    const productCat = productInfo && productInfo.productList[ownProps.pg];
    const { disableAutoHide, autoHideType } = Helpers.getAutoHideComponent(state.slugInfo, productCat);

    return {
        productCat: productCat
            ? {
                  ...productCat,
                  //if sortedProducts is passed in, use that as an override of the default productCat.products only when the sortValue is 'rank.recommended'
                  ...(sortedProducts && productCat.sortValue === 'rank.recommended'
                      ? { products: sortedProducts }
                      : {}),
              }
            : productCat,
        slugKey: state.slugInfo.key,
        disableAutoHide,
        autoHideType,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchProducts: key => dispatch(fetchProducts(key)),
        sortProducts: (sortValue, pg, analyticsLabel) => dispatch(sortProducts(sortValue, pg, analyticsLabel)),
        prefetchProducts: vanityUrl => dispatch(prefetchProducts(vanityUrl)),
    };
};

const WithProductContainer = Component => {
    return props => {
        return <Component {...props} />;
    };
};

export const withProductContainer = compose(connect(mapStateToProps, mapDispatchToProps), WithProductContainer);

export default connect(mapStateToProps, mapDispatchToProps)(withError(ProductList));
